import type { BaseTheme } from '.';
import type { Components } from '@mui/material/styles/components';

export const link: Components<BaseTheme> = {
  MuiLink: {
    defaultProps: {
      underline: 'hover',
    },

    styleOverrides: {
      root: {
        cursor: 'pointer',
      },
    },
  },
};
